var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 50,
    viewBox: "0 0 195 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-claro_play_logo_195x50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "claro_play_logo_195x50",
    "data-name": "claro play_logo_195x50",
    clipPath: "url(#clip-claro_play_logo_195x50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 50,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M106.216,40.46a6.046,6.046,0,1,1,6.045-6.045,6.045,6.045,0,0,1-6.045,6.045m-.028-17.49A11.414,11.414,0,1,0,117.6,34.383,11.413,11.413,0,0,0,106.188,22.97",
    transform: "translate(-20.707 -5.018)",
    fill: "#ff251c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M90.632,23.377v5.315c-4.265,0-5.368,1.366-6.15,2.837a7.741,7.741,0,0,0-.73,3.686V45.484H78.046V24.26h5.6v2.26a8.024,8.024,0,0,1,6.985-3.142",
    transform: "translate(-17.052 -5.106)",
    fill: "#ff251c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M62.681,34.63a6.112,6.112,0,0,1-1.07.541,9.08,9.08,0,0,1-1.484.383l-1.256.236a8.176,8.176,0,0,0-2.539.766,2.567,2.567,0,0,0-1.3,2.379,2.5,2.5,0,0,0,.8,2.074,3,3,0,0,0,1.938.639A5.716,5.716,0,0,0,61.1,40.587q1.525-1.062,1.584-3.874ZM59.3,32.015a8.635,8.635,0,0,0,2.206-.491A1.683,1.683,0,0,0,62.7,29.933a1.889,1.889,0,0,0-.914-1.819,5.69,5.69,0,0,0-2.68-.5,3.49,3.49,0,0,0-2.809.983,4.069,4.069,0,0,0-.786,1.966H50.183a8.266,8.266,0,0,1,1.558-4.619q2.2-2.83,7.551-2.831a13.3,13.3,0,0,1,6.188,1.4q2.705,1.4,2.705,5.268V39.6c0,.682-.011,5.9-.011,5.9l-5.492.1c0-.471,0-1.483,0-1.965a9.625,9.625,0,0,1-6.53,2.079,6.935,6.935,0,0,1-4.766-1.661A5.95,5.95,0,0,1,49.5,39.349a6.121,6.121,0,0,1,3.026-5.721,13.35,13.35,0,0,1,4.88-1.376Z",
    transform: "translate(-10.816 -5.049)",
    fill: "#ff251c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M106.856,14.009h5.095V0h-5.095Z",
    transform: "translate(-23.347 0)",
    fill: "#ff251c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M128.33,36.067H141V31.042H128.33Z",
    transform: "translate(-28.038 -6.782)",
    fill: "#ff251c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M124.118,20.156l-3.633-3.633L132.253,4.756l3.632,3.633Z",
    transform: "translate(-26.324 -1.039)",
    fill: "#ff251c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M14.086,38.356a8.624,8.624,0,1,1,7.758-12.1h5.929A14.137,14.137,0,0,0,14.086,15.318a14.321,14.321,0,0,0,0,28.639A14.125,14.125,0,0,0,27.619,33.61H21.657a8.465,8.465,0,0,1-7.57,4.746",
    transform: "translate(0 -3.347)",
    fill: "#ff251c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M38.583,44.163h5.57v-27.9h-5.57Z",
    transform: "translate(-8.43 -3.552)",
    fill: "#ff251c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M164.016,39.5a10.888,10.888,0,0,0,.374-3.447,10.9,10.9,0,0,0-.374-3.448,3.3,3.3,0,0,0-6.19,0,10.871,10.871,0,0,0-.374,3.448,10.864,10.864,0,0,0,.374,3.447,3.3,3.3,0,0,0,6.19,0ZM152.053,53.58a.393.393,0,0,1-.416-.415V26.412a.393.393,0,0,1,.416-.415h4.985a.393.393,0,0,1,.416.415v1.454h.041c.914-1.371,2.617-2.327,5.275-2.327a6.611,6.611,0,0,1,6.813,4.819,17.42,17.42,0,0,1,.706,5.692,17.582,17.582,0,0,1-.706,5.691,6.654,6.654,0,0,1-6.813,4.819c-2.659,0-4.361-.955-5.275-2.326h-.041v8.931a.393.393,0,0,1-.416.415Z",
    transform: "translate(-33.13 -5.58)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M187.049,44.2c-4.445,0-6.231-1.953-6.231-6.4V16.122a.392.392,0,0,1,.416-.415h4.985a.392.392,0,0,1,.415.415V37.349c0,1.372.541,1.911,1.744,1.911h.872a.393.393,0,0,1,.416.415v4.112a.392.392,0,0,1-.416.415Z",
    transform: "translate(-40.506 -3.432)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    d: "M208.136,39.415V38.044a.221.221,0,0,0-.249-.249h-2.826c-2.451,0-3.572.706-3.572,2.285,0,1.412,1,2.119,2.908,2.119,2.492,0,3.739-.914,3.739-2.783Zm.5,6.688a.393.393,0,0,1-.416-.415V44.358h-.042c-1.038,1.329-2.783,2.2-5.525,2.2-3.572,0-6.687-1.869-6.687-6.148,0-4.444,3.365-6.479,8.35-6.479h3.573a.221.221,0,0,0,.249-.249v-.748c0-1.869-.914-2.741-4.112-2.741a7.486,7.486,0,0,0-4.487,1.288A.331.331,0,0,1,199,31.4l-1.87-3.281a.4.4,0,0,1,.126-.581,12.741,12.741,0,0,1,7.477-1.994c6.564,0,8.931,2.243,8.931,7.27V45.687a.393.393,0,0,1-.416.415Z",
    transform: "translate(-44.815 -5.58)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M225.38,53.708a.392.392,0,0,1-.415-.415V49.221a.392.392,0,0,1,.415-.415h.872a2.558,2.558,0,0,0,2.742-2.076l.54-1.5L222.057,26.54c-.084-.249.083-.415.333-.415h5.317a.525.525,0,0,1,.5.415l4.03,11.632h.083l3.738-11.632a.528.528,0,0,1,.5-.415h5.151c.292,0,.415.166.333.415L233.9,47.934c-1.7,4.445-3.489,5.774-7.1,5.774Z",
    transform: "translate(-51.511 -5.708)",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a80f0dfdc532061213ead0f92aae8659.svg";
export { ForwardRef as ReactComponent };